import { render } from "./designations-index.vue?vue&type=template&id=6d7e0279"
import script from "./designations-index.vue?vue&type=script&lang=js"
export * from "./designations-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__